import { useEffect, useState, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TodosContext } from "../context";
import { scrollToTop } from "../utils/helpers/helperMethods/scrollToTop";
import { getAllLeads } from "../slices/leads/leadManagementSlice";
import { AppDispatch, RootState } from "../slices/store";
import useRequestLeads from "./useRequestLeads";
import UseAuthConfig from "./useAuthConfig";
import { useNavigate } from "react-router-dom";
import { handleDeleteCardService } from "../pages/leads-management/service/LeadService";


const useAllLeads = () => {
    const { protectedResources }: any = UseAuthConfig();
  const dispatch = useDispatch<AppDispatch>();
  const leadDetails = useSelector((state: RootState) => state.leadsManagement.allLeads);
  const status = useSelector((state: RootState) => state.leadsManagement.status);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { addAlert } = useContext(TodosContext);
  const [reqRequests, updateSettings] = useRequestLeads();
  const [activePage, setActivePage] = useState<number>(reqRequests.PageNumber);
  const navigate = useNavigate();
  
  useEffect(() => {
    if (!leadDetails?.succeeded && reqRequests) {
      dispatch(getAllLeads(reqRequests));
    }
    const activePageInLocal = localStorage.getItem("allLeadsActivePage");
    // if (activePageInLocal) {
    //   // setActivePage(parseInt(activePageInLocal));      
    // }
  }, [dispatch, leadDetails?.succeeded, reqRequests]);

  useEffect(() => {
    setIsLoading(false);
  }, [leadDetails]);

  useEffect(() => {
    localStorage.setItem("allLeadsActivePage", activePage.toString());
  }, [activePage]);

  useEffect(() => {
    dispatch(getAllLeads(reqRequests));
  }, [dispatch, reqRequests]);

  const handleSetFilteredValue = (inputValue: string) => {
    updateSettings({ SearchText: inputValue || "" });
  };

  const handlePageChange = (event: { selected: number }) => {
    setIsLoading(true);
    const { selected } = event;
    setActivePage(selected + 1);
    updateSettings({ PageNumber: selected + 1 });
    scrollToTop();
  };

  const handleDeleteCard = (data: any) => {
    handleDeleteCardService(
      data,
      reqRequests,
      setIsLoading,
      dispatch,
      addAlert,
      false,
      navigate,
      getAllLeads,
      protectedResources
    );
  };

  const pageSize =  reqRequests.PageSize;

  return {
    leadDetails,
    status,
    isLoading,
    activePage,
    handleSetFilteredValue,
    handlePageChange,
    handleDeleteCard,
    pageSize
  };
};

export default useAllLeads;
